
/*
*  时间转换，兼容ie
* @param {number} a
* @param {date} aaa
* @param {number} 关于该参数的描述
*/
export const onConversion = (date) => {
    // console.log(date);
    if (date.indexOf('T') === -1) {
        var nDate = new Date(date.replace(new RegExp(/-/gm), "/"));
        // let nDate = new Date(date),
        var y = nDate.getFullYear(),
            m = ("0" + (nDate.getMonth() + 1)).slice(-2),
            d = ("0" + nDate.getDate()).slice(-2);
        // console.log(date)
        return y + "-" + m + "-" + d;
    } else {
        var arr = date.split("T");
        var d = arr[0];
        var darr = d.split("-");

        var dd =
            parseInt(darr[0]) +
            "-" +
            parseInt(darr[1]) +
            "-" +
            parseInt(darr[2]) +
            " ";
        return dd;
    }

}
